export default __webpack_public_path__ + "static/media/Icon-PurchaseOrders.c9ab1b24.svg";